var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineStartLineArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 8.7073C-0.0976318 8.31677 -0.0976317 7.68361 0.292893 7.29308L6.65685 0.929124C7.04738 0.5386 7.68054 0.5386 8.07107 0.929124C8.46159 1.31965 8.46159 1.95281 8.07107 2.34334L3.41421 7.00019L23 7.00019C23.5523 7.00019 24 7.44791 24 8.00019C24 8.55248 23.5523 9.00019 23 9.00019L3.41421 9.00019L8.07107 13.657C8.46159 14.0476 8.46159 14.6807 8.07107 15.0713C7.68054 15.4618 7.04738 15.4618 6.65685 15.0713L0.292893 8.7073Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineStartLineArrow);
export default __webpack_public_path__ + "static/media/line_start_line_arrow.530975678c1430afe529f425a02918d5.svg";
export { ForwardRef as ReactComponent };